import { apiFirst, apiListAll, apiPatch, apiPost } from '@/core/api/resources'
import { composeMassnahmeSelection } from '@/core/lib/massnahme'
import type {
  MassnahmeOption,
  MassnahmeCreate,
  MassnahmePatch,
  MassnahmeRow,
  MassnahmeTbFields,
  MassnahmeUeBudget,
} from '@/core/data/massnahmen'
import type { MassnahmeAzavRead } from '../api/resources'
import { MASSNAHME_DEFAULTS } from '../massnahme'

function listRows(organisationId: string): Promise<MassnahmeAzavRead[]> {
  return apiListAll('/azav/massnahme', { organisation_id: organisationId, order: 'nummer' })
}

function toRow(m: MassnahmeAzavRead): MassnahmeRow {
  return {
    id: m.id,
    nummer: m.nummer,
    bezeichnung: m.bezeichnung,
    durchf_form: m.durchf_form,
    ue_anzahl: m.ue_anzahl,
    kosten: m.kosten,
    zeitl_umfang_woche: m.zeitl_umfang_woche,
    start_zulassung: m.start_zulassung,
    ende_zulassung: m.ende_zulassung,
    inhalt: m.inhalt,
    durchf_ort: m.durchf_ort,
    abschluss: m.abschluss,
    ziele_und_inhalt: m.ziele_und_inhalt,
    ansprechpartner: m.ansprechpartner,
  }
}

export async function listMassnahmenFull(organisationId: string): Promise<MassnahmeRow[]> {
  return (await listRows(organisationId)).map(toRow)
}

export async function createMassnahme(organisationId: string, patch: MassnahmeCreate): Promise<MassnahmeRow> {
  const created = await apiPost('/azav/massnahme', {
    ...MASSNAHME_DEFAULTS,
    ...patch,
    organisation_id: organisationId,
  })
  return toRow(created)
}

export async function updateMassnahme(id: string, patch: MassnahmePatch): Promise<void> {
  await apiPatch('/azav/massnahme/{id}', { id }, patch)
}

export async function getMassnahmeUeBudget(massnahmeId: string): Promise<MassnahmeUeBudget | null> {
  const row = await apiFirst('/azav/massnahme', { id: massnahmeId, limit: 1 })
  return row ? { ueAnzahl: row.ue_anzahl, label: composeMassnahmeSelection(String(row.nummer), row.bezeichnung) } : null
}

export async function listMassnahmen(organisationId: string): Promise<MassnahmeOption[]> {
  return (await listRows(organisationId)).map((m) => ({
    id: m.id,
    label: composeMassnahmeSelection(String(m.nummer ?? ''), m.bezeichnung),
    ue_anzahl: m.ue_anzahl,
  }))
}

export async function getMassnahmeTbFields(
  organisationId: string,
  nummer: string,
): Promise<MassnahmeTbFields | null> {
  const row = await apiFirst('/azav/massnahme', {
    organisation_id: organisationId,
    nummer,
    limit: 1,
  })
  if (!row) return null
  return {
    id: row.id,
    zeitl_umfang: row.zeitl_umfang_woche,
    ue_anzahl: row.ue_anzahl,
  }
}
